import React, { MouseEventHandler } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDidMountEffect } from '@/hooks/useDidMountEffect';
import signOut from "../../auth/api/signOut";
import { FlatRateAgreement } from "../../flatRates/types";

type HeaderProps = {
  flatRateAgreement?: FlatRateAgreement;
  requestType?: string;
  creditUrl?: string;
}

const Header: React.FC<HeaderProps> = ({
  flatRateAgreement,
  requestType,
  creditUrl
}) => {
  const navigate = useNavigate();
  const [activeAccordion, setActiveAccordion] = React.useState<string | null>(null);

  const toggleAccordion = (id: string) => {
    setActiveAccordion(prevActiveAccordion => prevActiveAccordion === id ? null : id);
  };

  const addClassHtml = () => {
    var element = document.documentElement;
    if (element) {
      element.classList.toggle("ov");
    }
  };

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();
    signOut();

    localStorage.clear();
    navigate('/customer/sign_in');
  };

  useDidMountEffect (() => {
    //accdiron menu
    var acc = document.getElementsByClassName("main-header__nav-click");
    var i;
  
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function(this: HTMLElement) {
        this.classList.toggle("active");
        var panel = this.nextElementSibling as HTMLElement | null;
        if (panel) {
          if (panel.style.display === "block") {
            panel.style.display = "none";
          } else {
            panel.style.display = "block";
          }
        }
      });
    }
  
    //click show menu
    var icons02 = document.querySelectorAll('.main-header__mobile-icon');
    icons02.forEach(icon => {
      icon.addEventListener('click', function(e) {
        const target = e.target as HTMLElement;
        const closestIcon = target.closest('.main-header__mobile-icon');
        if (closestIcon) {
          closestIcon.classList.toggle('mobile-close');
        }
      });
    });
  
    const acc02 = document.getElementsByClassName("main-header__mobile-icon");
    Array.from(acc02).forEach((currentElement) => {
      currentElement.addEventListener("click", () => {
        currentElement.classList.toggle("mobile-close");
      });
    });
  
    for (let j = 0; j < acc02.length; j++) {
      acc02[j].addEventListener("click", () => {
        const currentElement = acc02[j] as HTMLElement;
        currentElement.classList.toggle("mobile-close");
        const panel02 = currentElement.nextElementSibling as HTMLElement | null;
        if (panel02) {
          panel02.style.display = panel02.style.display === "block" ? "none" : "block";
        }
      });
    }
  
    var closeClick = document.getElementsByClassName("main-header__close");
    var x;
    for (x = 0; x < closeClick.length; x++) {
      closeClick[x].addEventListener("click", function(this: HTMLElement) {
        this.classList.toggle("active");
        var panel = this.parentElement as HTMLElement;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
        if (panel.previousElementSibling instanceof HTMLElement) {
          panel.previousElementSibling.classList.toggle('mobile-close');
        }
      });
    }
  
    //sidevar menu fixed
    var sections = document.querySelectorAll('.js-item');
    var navLinks = document.querySelectorAll('.js-scroll a');
    window.onscroll = () => {
      sections.forEach((sec) => {
        if (!(sec instanceof HTMLElement)) return;
        var top = window.scrollY;
        var offset = sec.offsetTop + 220;
        var height = sec.offsetHeight;
        var id = sec.getAttribute('id');
        if (top >= offset && top < offset + height) {
          navLinks.forEach((link) => {
            if (!(link instanceof HTMLElement)) return;
            link.classList.remove('active');
            if (id) {
              var activeLink = document.querySelector(`.js-scroll a[href*="${id}"]`);
              if (activeLink instanceof HTMLElement) {
                activeLink.classList.add('active');
              }
            }
          });
        }
      });
    };
  }, [])

  return (
    <React.Fragment>
      <header id="main-header" className="main-header main-header--page main-header--user">
        <div className="main-header__inner">
          <Link to="/customer/top" className="main-header__logo">
            <picture>
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-white-sp.webp`} media="(max-width:834px)" type="image/webp" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/common/logo-white-sp.png`} media="(max-width:834px)" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-white.webp`} type="image/webp" />
              <img src={`${process.env.PUBLIC_URL}/img/common/logo-white.png`} alt="SEED" />
            </picture>
          </Link>
          <nav className="main-header__navGlobal pc">
            <ul className="main-header__menu">
              <li className="main-header__menu-item"><Link to="" onClick={handleClick}>ログアウト</Link></li>
            </ul>
          </nav>
        </div>
        <span className="main-header__mobile-icon"
          onClick={addClassHtml}
          onKeyPress={(e) => {
            if(e.key === "Enter") {
              addClassHtml();
            }
          }}
        >
          <span className="main-header__mobile-icon-border"></span>
          <span className="main-header__mobile-icon-border"></span>
          <span className="main-header__mobile-icon-border"></span>
        </span>
        <div className="main-header__main">
          <ul className="main-header__nav">
            {flatRateAgreement?.status === "before_confirmation" && 
              <li className="main-header__nav-item">
                <div
                  className={`main-header__nav-click ${activeAccordion === "new-contract" ? "active" : ""}`}
                  onClick={() => toggleAccordion("new-contract")}
                >
                  新規契約の確認・確定 <span className="accordion"></span>
                </div>
                <ul className="main-header__children" style={{ display: activeAccordion === "new-contract" ? "block" : "none" }}>
                  <li className="main-header__children-item">
                    <Link to="/customer/flat_rates/registration">
                      新規契約申込入力
                    </Link>
                  </li>
                </ul>
              </li>
            }
            {(requestType && requestType === 'change_plan_request') && 
              <li className="main-header__nav-item">
                <div
                  className={`main-header__nav-click ${activeAccordion === "new-contract" ? "active" : ""}`}
                  onClick={() => toggleAccordion("new-contract")}
                >
                  契約内容変更の確認・確定 <span className="accordion"></span>
                </div>
                <ul className="main-header__children" style={{ display: activeAccordion === "new-contract" ? "block" : "none" }}>
                  <li className="main-header__children-item">
                    <Link to="/customer/flat_rates/change_plan_request/confirm">
                      契約内容変更の確認・確定
                    </Link>
                  </li>
                </ul>
              </li>
            }
            {(requestType && requestType === 'cancel_request') && 
              <li className="main-header__nav-item">
                <div
                  className={`main-header__nav-click ${activeAccordion === "new-contract" ? "active" : ""}`}
                  onClick={() => toggleAccordion("new-contract")}
                >
                  キャンセル内容の確認・確定 <span className="accordion"></span>
                </div>
                <ul className="main-header__children" style={{ display: activeAccordion === "new-contract" ? "block" : "none" }}>
                  <li className="main-header__children-item">
                    <Link to="/customer/flat_rates/cancel_request/confirm">
                      キャンセル内容の確認・確定
                    </Link>
                  </li>
                </ul>
              </li>
            }
            {(requestType && requestType === 'terminate_request') && 
              <li className="main-header__nav-item">
                <div
                  className={`main-header__nav-click ${activeAccordion === "new-contract" ? "active" : ""}`}
                  onClick={() => toggleAccordion("new-contract")}
                >
                  解約内容の確認・確定 <span className="accordion"></span>
                </div>
                <ul className="main-header__children" style={{ display: activeAccordion === "new-contract" ? "block" : "none" }}>
                  <li className="main-header__children-item">
                    <Link to="/customer/flat_rates/terminate_request/confirm">
                      解約内容の確認・確定
                    </Link>
                  </li>
                </ul>
              </li>
            }
            {(requestType && requestType === 'lost_non_warranty_request') && 
              <li className="main-header__nav-item">
                <div
                  className={`main-header__nav-click ${activeAccordion === "new-contract" ? "active" : ""}`}
                  onClick={() => toggleAccordion("new-contract")}
                >
                  保証外紛失レンズ内容の確認・確定<span className="accordion"></span>
                </div>
                <ul className="main-header__children" style={{ display: activeAccordion === "new-contract" ? "block" : "none" }}>
                  <li className="main-header__children-item">
                    <Link to="/customer/flat_rates/lost_non_warranty_request/confirm">
                      保証外紛失レンズ内容の確認・確定
                    </Link>
                  </li>
                </ul>
              </li>
            }
            {flatRateAgreement?.status !== "before_confirmation" &&
              <>
                <li className="main-header__nav-item">
                  <div className="main-header__nav-click"> お客様ご登録基本<br className="pc" />情報の変更 <span className="accordion"></span>
                  </div>
                  <ul className="main-header__children">
                    <li className="main-header__children-item">
                      <Link to="/customer/edit_info">お客様ご登録基本情報の変更</Link>
                    </li>
                  </ul>
                </li>
                <li className="main-header__nav-item">
                  <div className="main-header__nav-click"> ご登録クレジットカード<br className="pc" />情報の変更 <span className="accordion"></span>
                  </div>
                  <ul className="main-header__children">
                    <li className="main-header__children-item"><Link to={creditUrl || ""}>ご登録クレジットカード情報の変更</Link></li>
                  </ul>
                </li>
              </>
            }
          </ul>
          <div className="sp">
            <div className="c-al--c">
              <Link to="" className="main-header__logout c-btn__02">ログアウト</Link>
            </div>
          </div>
          <div className="main-header__close sp"
            onClick={() =>{addClassHtml()}}
            onKeyPress={(e: any)=>{
              if(e.key==="Click") {addClassHtml()}
              }}
          >
            ✕　閉じる
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default React.memo(Header);